import styled from 'styled-components';

import { colors } from '@/globalStyles';


export const SelectButton = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 24px;
  padding: 0 10px 0 20px;
  cursor: pointer;
  background-color: #ffffff;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.black};
`;

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 70px);
  grid-auto-rows: 70px;
  gap: 15px;
  justify-content: center;
  padding: 22px 15px;
  background-color: ${colors.white};
  border-radius: 4px;
  width: 100%;
`;

export const SymbolImageContainer = styled.img`
  width: 70px;
  height: 70px;
  color: #4e4e4e;
  border: solid 1px ${colors.lightShadeGray};
  padding: 0;
  position: relative;
  border-radius: 4px;

  &:hover, &.selected {
    border-color: ${colors.primary};
    color: ${colors.primary};
    cursor: pointer;
  }
`;

export const Icon = styled.img`
  width: 30px;
  height: 30px;
`;